import { useState } from "react";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { ADD_CHANNEL } from "src/constants/mutations";
import { successToast } from "src/utils/toasts";
import { AddChannelInput } from "src/interfaces/channel.interface";

export const useAddChannel = () => {
  const { axBe } = useAxiosInterceptor();
  const [isAddingChannel, setIsAddingChannel] = useState(false);

  const addChannel = async (
    addChannelInput: AddChannelInput,
    callbacks?: {
      onSuccess?: () => void;
      onError?: (error: any) => void;
    }
  ) => {
    setIsAddingChannel(true);
    try {
      const { data: addedChannel } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: ADD_CHANNEL,
        variables: { addChannelInput: { ...addChannelInput } },
      });

      if (addedChannel?.errors?.length) throw addedChannel.errors[0];
      const created = addedChannel?.data?.addChannel;
      if (!created?.correlationId) throw new Error("Channel creation failed.");

      successToast("Channel has been created successfully!");
      callbacks?.onSuccess?.();
    } catch (error: any) {
      console.error("Error creating channel:", error);
      callbacks?.onError?.(error);
    } finally {
      setIsAddingChannel(false);
    }
  };

  return {
    addChannel,
    isAddingChannel,
  };
};
